import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './img/pharmaceutical/feature1.png';
import _imports_1 from './img/pharmaceutical/feature2.png';
import _imports_2 from './img/pharmaceutical/feature3.png';
import _imports_3 from './img/pharmaceutical/feature4.png';
import _imports_4 from './img/pharmaceutical/feature5.png';
import _imports_5 from './img/pharmaceutical/worth1.png';
import _imports_6 from './img/pharmaceutical/worth2.png';
import _imports_7 from './img/pharmaceutical/worth3.png';
import _imports_8 from './img/pharmaceutical/worth4.png';
import _imports_9 from './img/pharmaceutical/worth5.png';
import _imports_10 from './img/pharmaceutical/superiority1.png';
import _imports_11 from './img/pharmaceutical/superiority2.png';
import _imports_12 from './img/pharmaceutical/superiority3.png';
import _imports_13 from './img/pharmaceutical/superiority4.png';
import _imports_14 from './img/pharmaceutical/superiority5.png';
import _imports_15 from './img/case3.png';
import _imports_16 from './img/haooubo.png';
import _imports_17 from './img/pharmacy.png';
const _hoisted_1 = {
  class: "pharmaceutical-case"
};
const _hoisted_2 = {
  class: "pharmaceutical-case-banner"
};
const _hoisted_3 = {
  class: "case-info"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "desc"
};
const _hoisted_6 = {
  class: "feature-box"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "feature-lists"
};
const _hoisted_9 = {
  class: "feature-item"
};
const _hoisted_10 = {
  class: "feature-title"
};
const _hoisted_11 = {
  class: "feature-desc"
};
const _hoisted_12 = {
  class: "feature-item"
};
const _hoisted_13 = {
  class: "feature-title"
};
const _hoisted_14 = {
  class: "feature-desc"
};
const _hoisted_15 = {
  class: "feature-item"
};
const _hoisted_16 = {
  class: "feature-title"
};
const _hoisted_17 = {
  class: "feature-desc"
};
const _hoisted_18 = {
  class: "feature-item"
};
const _hoisted_19 = {
  class: "feature-title"
};
const _hoisted_20 = {
  class: "feature-desc"
};
const _hoisted_21 = {
  class: "feature-item"
};
const _hoisted_22 = {
  class: "feature-title"
};
const _hoisted_23 = {
  class: "feature-desc"
};
const _hoisted_24 = {
  class: "worth-box"
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  class: "worth-content"
};
const _hoisted_27 = {
  class: "worth-item"
};
const _hoisted_28 = {
  class: "worth-info"
};
const _hoisted_29 = {
  class: "sub-title"
};
const _hoisted_30 = {
  class: "sub-desc"
};
const _hoisted_31 = {
  class: "worth-item"
};
const _hoisted_32 = {
  class: "worth-info"
};
const _hoisted_33 = {
  class: "sub-title"
};
const _hoisted_34 = {
  class: "sub-desc"
};
const _hoisted_35 = {
  class: "worth-item"
};
const _hoisted_36 = {
  class: "worth-info"
};
const _hoisted_37 = {
  class: "sub-title"
};
const _hoisted_38 = {
  class: "sub-desc"
};
const _hoisted_39 = {
  class: "worth-item"
};
const _hoisted_40 = {
  class: "worth-info"
};
const _hoisted_41 = {
  class: "sub-title"
};
const _hoisted_42 = {
  class: "sub-desc"
};
const _hoisted_43 = {
  class: "worth-item"
};
const _hoisted_44 = {
  class: "worth-info"
};
const _hoisted_45 = {
  class: "sub-title"
};
const _hoisted_46 = {
  class: "sub-desc"
};
const _hoisted_47 = {
  class: "superiority-box"
};
const _hoisted_48 = {
  class: "title"
};
const _hoisted_49 = {
  class: "superiority-content"
};
const _hoisted_50 = {
  class: "superiority-item"
};
const _hoisted_51 = {
  class: "superiority-info"
};
const _hoisted_52 = {
  class: "superiority-title"
};
const _hoisted_53 = {
  class: "superiority-desc"
};
const _hoisted_54 = {
  class: "superiority-item"
};
const _hoisted_55 = {
  class: "superiority-info"
};
const _hoisted_56 = {
  class: "superiority-title"
};
const _hoisted_57 = {
  class: "superiority-desc"
};
const _hoisted_58 = {
  class: "superiority-item"
};
const _hoisted_59 = {
  class: "superiority-info"
};
const _hoisted_60 = {
  class: "superiority-title"
};
const _hoisted_61 = {
  class: "superiority-desc"
};
const _hoisted_62 = {
  class: "superiority-item"
};
const _hoisted_63 = {
  class: "superiority-info"
};
const _hoisted_64 = {
  class: "superiority-title"
};
const _hoisted_65 = {
  class: "superiority-desc"
};
const _hoisted_66 = {
  class: "superiority-item"
};
const _hoisted_67 = {
  class: "superiority-info"
};
const _hoisted_68 = {
  class: "superiority-title"
};
const _hoisted_69 = {
  class: "superiority-desc"
};
const _hoisted_70 = {
  class: "more-case"
};
const _hoisted_71 = {
  class: "case-title"
};
const _hoisted_72 = {
  class: "desc"
};
const _hoisted_73 = {
  class: "more-case-box"
};
const _hoisted_74 = {
  class: "case-info"
};
const _hoisted_75 = {
  class: "tag"
};
const _hoisted_76 = {
  class: "tag"
};
const _hoisted_77 = {
  class: "tag"
};
const _hoisted_78 = {
  class: "tag"
};
const _hoisted_79 = {
  class: "title"
};
const _hoisted_80 = {
  class: "case-desc"
};
const _hoisted_81 = {
  class: "link-txt"
};
const _hoisted_82 = {
  class: "case-info"
};
const _hoisted_83 = {
  class: "tag"
};
const _hoisted_84 = {
  class: "tag"
};
const _hoisted_85 = {
  class: "title"
};
const _hoisted_86 = {
  class: "case-desc"
};
const _hoisted_87 = {
  class: "case-info"
};
const _hoisted_88 = {
  class: "tag"
};
const _hoisted_89 = {
  class: "tag"
};
const _hoisted_90 = {
  class: "tag"
};
const _hoisted_91 = {
  class: "title"
};
const _hoisted_92 = {
  class: "case-desc"
};
const _hoisted_93 = {
  class: "link-txt"
};
const _hoisted_94 = {
  class: "bottom-banner"
};
const _hoisted_95 = {
  class: "banner-con"
};
const _hoisted_96 = {
  class: "banner-content"
};
const _hoisted_97 = {
  class: "title"
};
const _hoisted_98 = {
  class: "desc"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'pharmaceutical',
  setup(__props) {
    const router = useRouter();
    const advisoryServiceRef = ref(null);
    const goAdvisory = () => {
      advisoryServiceRef['value'].show();
    };
    const toCasePage = path => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      router.push(`/successCase/${path}`);
    };
    return (_ctx, _cache) => {
      const _component_AdvisoryService = _resolveComponent("AdvisoryService");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('pharmaceutical.text1')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pharmaceutical.text2')), 1), _createElementVNode("div", {
        class: "doc-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('pharmaceutical.text3')), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('pharmaceutical.text4')), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_0
      }, null, -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('pharmaceutical.text5')), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('pharmaceutical.text6')), 1)]), _createElementVNode("div", _hoisted_12, [_cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_1
      }, null, -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('pharmaceutical.text7')), 1), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('pharmaceutical.text8')), 1)]), _createElementVNode("div", _hoisted_15, [_cache[6] || (_cache[6] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_2
      }, null, -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('pharmaceutical.text9')), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('pharmaceutical.text10')), 1)]), _createElementVNode("div", _hoisted_18, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_3
      }, null, -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('pharmaceutical.text11')), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('pharmaceutical.text12')), 1)]), _createElementVNode("div", _hoisted_21, [_cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "feature-img",
        src: _imports_4
      }, null, -1)), _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('pharmaceutical.text13')), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('pharmaceutical.text14')), 1)]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "feature-item"
      }, null, -1))])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.$t('pharmaceutical.text15')), 1), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_cache[10] || (_cache[10] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_5
      }, null, -1)), _createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('pharmaceutical.text13')), 1), _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('pharmaceutical.text16')), 1)])]), _createElementVNode("div", _hoisted_31, [_cache[11] || (_cache[11] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_6
      }, null, -1)), _createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('pharmaceutical.text17')), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('pharmaceutical.text18')), 1)])]), _createElementVNode("div", _hoisted_35, [_cache[12] || (_cache[12] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_7
      }, null, -1)), _createElementVNode("div", _hoisted_36, [_createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('pharmaceutical.text19')), 1), _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('pharmaceutical.text20')), 1)])]), _createElementVNode("div", _hoisted_39, [_cache[13] || (_cache[13] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_8
      }, null, -1)), _createElementVNode("div", _hoisted_40, [_createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('pharmaceutical.text21')), 1), _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('pharmaceutical.text22')), 1)])]), _createElementVNode("div", _hoisted_43, [_cache[14] || (_cache[14] = _createElementVNode("img", {
        class: "worth-icon",
        src: _imports_9
      }, null, -1)), _createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('pharmaceutical.text23')), 1), _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('pharmaceutical.text24')), 1)])])])]), _createElementVNode("div", _hoisted_47, [_createElementVNode("h3", _hoisted_48, _toDisplayString(_ctx.$t('pharmaceutical.text25')), 1), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_cache[15] || (_cache[15] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_10
      }, null, -1)), _createElementVNode("div", _hoisted_51, [_createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t('pharmaceutical.text26')), 1), _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('pharmaceutical.text27')), 1)])]), _createElementVNode("div", _hoisted_54, [_cache[16] || (_cache[16] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_11
      }, null, -1)), _createElementVNode("div", _hoisted_55, [_createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('pharmaceutical.text28')), 1), _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('pharmaceutical.text29')), 1)])]), _createElementVNode("div", _hoisted_58, [_cache[17] || (_cache[17] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_12
      }, null, -1)), _createElementVNode("div", _hoisted_59, [_createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('pharmaceutical.text13')), 1), _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t('pharmaceutical.text30')), 1)])]), _createElementVNode("div", _hoisted_62, [_cache[18] || (_cache[18] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_13
      }, null, -1)), _createElementVNode("div", _hoisted_63, [_createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('pharmaceutical.text31')), 1), _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t('pharmaceutical.text32')), 1)])]), _createElementVNode("div", _hoisted_66, [_cache[19] || (_cache[19] = _createElementVNode("img", {
        class: "superiority-icon",
        src: _imports_14
      }, null, -1)), _createElementVNode("div", _hoisted_67, [_createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('pharmaceutical.text33')), 1), _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('pharmaceutical.text34')), 1)])]), _cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "superiority-item",
        style: {
          "opacity": "0"
        }
      }, null, -1))])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("h3", _hoisted_71, _toDisplayString(_ctx.$t('successCase.text181')), 1), _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('successCase.text182')), 1), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", {
        class: "case-item",
        onClick: _cache[0] || (_cache[0] = $event => toCasePage('hinova'))
      }, [_cache[21] || (_cache[21] = _createElementVNode("img", {
        class: "case-img",
        src: _imports_15
      }, null, -1)), _createElementVNode("div", _hoisted_74, [_createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.$t('successCase.text65')), 1), _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t('successCase.text66')), 1), _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t('successCase.text67')), 1), _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('successCase.text68')), 1), _createElementVNode("h4", _hoisted_79, _toDisplayString(_ctx.$t('successCase.text64')), 1), _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t('successCase.text69')) + "......", 1), _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.$t('successCase.text183')) + " >", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[2] || (_cache[2] = $event => toCasePage('haooubo'))
      }, [_cache[22] || (_cache[22] = _createElementVNode("img", {
        class: "case-img",
        src: _imports_16
      }, null, -1)), _createElementVNode("div", _hoisted_82, [_createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.$t('successCase.text65')), 1), _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('successCase.text66')), 1), _createElementVNode("h4", _hoisted_85, _toDisplayString(_ctx.$t('successCase.text134')), 1), _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t('successCase.text135')) + "......", 1), _createElementVNode("p", {
        class: "link-txt",
        onClick: _cache[1] || (_cache[1] = $event => toCasePage('haooubo'))
      }, _toDisplayString(_ctx.$t('successCase.text183')) + " >", 1)])]), _createElementVNode("div", {
        class: "case-item",
        onClick: _cache[3] || (_cache[3] = $event => toCasePage('pharmacy'))
      }, [_cache[23] || (_cache[23] = _createElementVNode("img", {
        class: "case-img",
        src: _imports_17
      }, null, -1)), _createElementVNode("div", _hoisted_87, [_createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t('successCase.text50')), 1), _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('successCase.text53')), 1), _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.$t('successCase.text54')), 1), _createElementVNode("h4", _hoisted_91, _toDisplayString(_ctx.$t('successCase.text520')), 1), _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$t('successCase.text55')) + "......", 1), _createElementVNode("p", _hoisted_93, _toDisplayString(_ctx.$t('successCase.text183')) + " >", 1)])])])]), _createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("h3", _hoisted_97, _toDisplayString(_ctx.$t('pharmaceutical.text35')), 1), _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t('pharmaceutical.text36')), 1), _createElementVNode("span", {
        class: "consult-btn",
        onClick: goAdvisory
      }, _toDisplayString(_ctx.$t('pharmaceutical.text3')), 1)])])]), _createVNode(_component_AdvisoryService, {
        ref_key: "advisoryServiceRef",
        ref: advisoryServiceRef
      }, null, 512)]);
    };
  }
});